import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const ChoiceField = ({ label, value, onChange, options, testid }) => {
  const custom = value && !options.includes(value);
  const [mode, setMode] = useState(custom ? "__custom" : value || "");
  return (
    <>
      <span className="info-label">{label}</span>
      <select value={mode} onChange={(e) => { setMode(e.target.value); onChange(e.target.value === "__custom" ? "" : e.target.value); }} data-testid={`${testid}-select`}>
        <option value="" label="None" />
        {options.map((o) => <option key={o} value={o} label={o} />)}
        <option value="__custom" label="Custom…" />
      </select>
      {mode === "__custom" && (
        <input placeholder={`Custom ${label.toLowerCase()}`} value={value} maxLength={40} onChange={(e) => onChange(e.target.value)} data-testid={`${testid}-custom-input`} />
      )}
    </>
  );
};

export const ClassifyFields = ({ event, setting, landmark, onEvent, onSetting, onLandmark }) => {
  const [lists, setLists] = useState({ events: [], settings: [], landmarks: [] });
  useEffect(() => {
    const t = setTimeout(() => api.get("/landmarks/suggest", { params: { q: landmark } }).then((r) => setLists(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [landmark]);
  if (!lists.events.length) return null;
  return (
    <>
      <ChoiceField label="Event" value={event} onChange={onEvent} options={lists.events} testid="edit-event" />
      <ChoiceField label="Setting" value={setting} onChange={onSetting} options={lists.settings} testid="edit-setting" />
      <span className="info-label">Landmark</span>
      <input placeholder="e.g. Eiffel Tower" list="landmark-suggestions" value={landmark} maxLength={80} onChange={(e) => onLandmark(e.target.value)} data-testid="edit-landmark-input" />
      <datalist id="landmark-suggestions">{lists.landmarks.map((l) => <option key={l} value={l} />)}</datalist>
    </>
  );
};
